import { Typography } from '@mui/material';
import { FC } from 'react';

interface IStandardFeaturesAlwaysIncluded {
  name: string;
}
export const StandardFeaturesAlwaysIncluded: FC<IStandardFeaturesAlwaysIncluded> = ({ name }) => {
  return <Typography key={name}>{name}</Typography>;
};
